<template>
    <div>
        <validation-observer ref="buttonGroupForm">
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <label   :for="id" :class="{' col-md-3 col-xs-4 info-box-side-label' : isInquiry , 'attribute-label' : !isInquiry}">
                    {{ question.question_text }}
                </label>
                <div v-if="question" class="btngroup-input checkbox-attribute" :class="{' col-md-9  col-xs-8' : isInquiry}">
                    <input type="hidden" :value="id" name="questions[]">
                    <ul>
                        <li v-for="(option,index) of question.options" :key="index"
                            :class="{'selected': isSelected(option) , 'new-inputs':true}"
                            @click="onClick(option)">
                            <input type="radio" :id="id+'-'+option.id" :name="name"  :value="option.id" :checked="isSelected(option)" style="display: none;" />
                            <span class="input-value">
                                {{ option.option }}
                            </span>
                        </li>
                    </ul>

                </div>

                <validation-provider v-slot="{errors}" :rules="question.mandatory ? 'required' : ''">
                    <div v-if="selected" class="display-none">
                        <input :id="id" :name="name" :value="selected" type="radio">
                        <input type="hidden" :value="id" name="questions[]">
                    </div>
                    <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>

                </validation-provider>
                <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
            </div>
        </validation-observer>

    </div>
</template>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormButtonGroup",
    props: {
        value: {},
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
      return {
        question: {
          ...this.value
        },
        selected: null,
      }
    },
    computed: {
        /**
         * get input input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        }
    },
    methods: {
        /**
         * pick a value
         * @param option
         */
        onClick(option) {

            let alreadySelected = false;
            if (this.selected == option.id) {
                alreadySelected = true;
            }

            if (!alreadySelected) {
                this.question.answer_text = null;
                this.check(option)
            }

            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry(this.selected, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }
        },
        uncheck() {
            this.selected = [];
            this.question.value = {};
        },
        check(option) {
            this.selected = option.id;
            this.question.value = option;
            this.question.answer_text_names = option.option
            this.question.answer_text = option.id
        },
        /**
         * TODO: Make sure that its retrievable
         * @returns {*|{}}
         */
        retrieveSelected() {
            if (this.question && this.selected) {
                return this.selected
                // .find(selected => selected.id == +this.input.service_input_value)
            }
            return this.question && Object.keys((this.question || {}).selected || {}) ? this.question.selected : {};
        },
        triggerChange() {
            EventBus.$emit('onFormsFieldUpdated', this.question.service_id, this.clone)
        },
        addEventListeners() {
            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                if(this.$refs.buttonGroupForm){
                    verify(await this.$refs.buttonGroupForm.validate())
                }
            })
        },
        removeEventListeners(){
          EventBus.$off('onFormsAndCheckListsValidation');
        },
        isSelected(option){
            if(this.question.answer_text){
                if(this.question.answer_text == option.id){
                    return true;
                }
            }else{
                if(this.selected == option.id){
                    return true;
                }
            }

        },

    },
    mounted() {
        this.addEventListeners();
        if(this.question.answer_text){
            this.selected = this.question.answer_text;
        }
    },
    watch: {
        question: {
            handler(question) {
                this.$emit('input', question)
            },
            deep: true
        }
    },
    destroyed() {
        this.removeEventListeners();
    }
}
</script>

<style scoped>
.selected {
    font-weight: bold !important;
}
.p-0-1{
    padding:0px 1px;
}

@media screen and (min-width: 1px) and (max-width: 428px) {
    .change-form-list-in-inquiry {
        /*width: 57%;*/
        /*margin-left: 15px !important;*/
    }
}
@media screen and (min-width: 768px) and (max-width: 1440px) {
    .change-form-list-in-inquiry {
        margin-left: 0px !important;
    }
}

.info-box-side-label{
    word-break: break-all;
}

</style>